export const WORDMARK_PART = {
    balls: "balls",
    ballPrototype: "ball-prototype",
    letter: "letter",
    hit: "hit",
} as const;

export const WORDMARK_STATE_ATTRIBUTE = {
    waiting: "data-waiting",
    hot: "data-hot",
} as const;

export function partSelector(part: keyof typeof WORDMARK_PART): string {
    return `[data-part="${WORDMARK_PART[part]}"]`;
}
